import deltas from "../../actions/deltas";
import createModalIdStateReducer from "../../helpers/createModalIdStateReducer";

const {SET_FAILED_PAYMENT_PROCESSES_MORE_INFO_MODAL_ID_STATE} = deltas.actionTypes;

export default createModalIdStateReducer(SET_FAILED_PAYMENT_PROCESSES_MORE_INFO_MODAL_ID_STATE);

export const selectFailedPaymentProcessesMoreInfoModalId = state => state.states.failedPaymentProcessesMoreInfoModalId.id;
